var motivationForm = {
    bindings : {
        addMsg: '&'
    },
    /**
     * @ngInject
     */
    controller : function MotivationFormCtrl ($sce, $timeout, flux, actions) {
        
        var ctrl = this;
        var formData = {};
        var selectedMotivation = [];
        ctrl.motivation = [
            {
                id: 'Tjene mine egne penge',
                selected: false
            },
            {
                id: 'Lave noget fornuftigt i min fritid',
                selected: false
            },
            {
                id: 'Arbejde med mennesker',
                selected: false
            },
            {
                id: 'Vigtigt for mine fremtidsplaner',
                selected: false
            },
            {
                id: 'Møde nye mennesker og kollegaer',
                selected: false
            },
            {
                id: 'Mere arbejdserfaring',
                selected: false
            },
            {
                id: 'Mere viden om arbejdsmarkedet',
                selected: false
            },
            {
                id: 'Flere kompetencer',
                selected: false
            },
            {
                id: 'Erfaring inden for dette arbejdsområde',
                selected: false
            },
            {
                id: 'Søge nye udfordringer                                                                                                                                                                                                                                                                                       ',
                selected: false
            }
        ];
       

        function init () {
        }

        function link () {
        }

        function onChanges (changes) {
        }

        ctrl.submitForm = function submitForm() {
            
            if(selectedMotivation.length === 3) {
                formData.motivation = selectedMotivation;
                ctrl.addMsg({
                    $event: {
                        content: $sce.trustAsHtml('<span class="text-answer">'+selectedMotivation[0]+'</span><span class="text-answer">'+selectedMotivation[1]+'</span><span class="text-answer">'+selectedMotivation[2]+'</span>'),
                        type: 'send'
                    }
                });
                flux.dispatch(actions.UPDATE_USER, formData);
                $timeout(function() {
                    ctrl.addMsg({
                        $event: {
                            content: $sce.trustAsHtml('Det er nogle rigtig gode grunde, som du har valgt. <a href="/din-ansoegning">Godkend dit valg ved at trykke her.</a> '),
                            type: 'receive'
                        }
                    });
                }, 1000);
            } else {
                ctrl.addMsg({
                    $event: {
                        content: $sce.trustAsHtml('Ups, du skal vælge 3 sætninger.'),
                        type: 'receive'
                    }
                });
            }
        };

        ctrl.onMotivationChange = function onMotivationChange(target){
            if(selectedMotivation.length == 3) {
                target.selected = false;
            }
            selectedMotivation = _.chain(ctrl.motivation).filter({'selected':true}).map('id').value();
        };

        this.$onInit = init;
        this.$postLink = link;
        this.$onChanges = onChanges;
    },
    templateUrl: './angular/components/motivation-form.component.html',
};